module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网新闻")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('p', {
    staticClass: "formTitle"
  }, [_vm._v("新闻信息填写")]), _vm._v(" "), _c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("图片上传")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    attrs: {
      "multiple": "",
      "type": "drag",
      "action": "/zm/cos/upload",
      "on-success": _vm.uploadSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag images here to upload")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上传地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', _vm._l((_vm.imgPath), function(value, index) {
    return _c('li', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "dodgerblue"
      }
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" " + _vm._s(value.path) + "\n              "), _c('Button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.copyTo(value.path)
        }
      }
    }, [_vm._v("将该地址复制到图片地址中")])], 1)
  }), 0)])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("封面图预览")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.formItem.titleImgUrl
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("封面图地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formItem.titleImgUrl),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "titleImgUrl", $$v)
      },
      expression: "formItem.titleImgUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("主标题")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入主标题..."
    },
    model: {
      value: (_vm.formItem.mainTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "mainTitle", $$v)
      },
      expression: "formItem.mainTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("来源")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入来源..."
    },
    model: {
      value: (_vm.formItem.source),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "source", $$v)
      },
      expression: "formItem.source"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("新闻类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.newsCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "newsCategory", $$v)
      },
      expression: "formItem.newsCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("公司新闻")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("行业动态")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("媒体报导")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "datetime",
      "placeholder": "Select date",
      "format": "yyyy-MM-dd HH:mm"
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入简介..."
    },
    model: {
      value: (_vm.formItem.summary),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "summary", $$v)
      },
      expression: "formItem.summary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详细内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请输入详细内容..."
    },
    model: {
      value: (_vm.formItem.content),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "content", $$v)
      },
      expression: "formItem.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.isNew) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitTotal
    }
  }, [_vm._v("添加新闻")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("提交修改")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9a7bf0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/material-blocks/editNewsInfo.vue
// module id = uJYQ
// module chunks = 0